<template lang="pug">
  #system-error
    .container.pt-3
      b-card.mt-1.form-box.mx-auto.text-center.justify-content-center(body-class="px-5")
        p.mx-auto.mt-5.mb-3.white-space-pre-wrap {{error_msg}}
</template>

<script>
export default {
  name: "RelatedTmpOrder",
  props: {
    error_msg: {type: String, required: true}
  },
}
</script>

<style scoped>
.white-space-pre-wrap {
  white-space: pre-wrap;
}
</style>